import React from "react";

export default function MobileMenuArea({color, onClick}) {

    return <div style={{alignContent: "center", marginTop: 5, cursor:"pointer"}}>
        <i className="pi pi-bars" style={{marginLeft: 10, fontSize: 40, color: color ? color : "white"}}
           onClick={(e) => onClick(e)}/><br/>
        <span style={{color: color ? color : "white", marginLeft: 10}}>MENÜ</span>
    </div>
}